/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventInfo,
    JsonEventInfoFromJSON,
    JsonEventInfoFromJSONTyped,
    JsonEventInfoToJSON,
} from './JsonEventInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventInfo
 */
export interface ApiResultOfJsonEventInfo {
    /**
     * 
     * @type {JsonEventInfo}
     * @memberof ApiResultOfJsonEventInfo
     */
    data?: JsonEventInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventInfo
     */
    result?: ApiResultOfJsonEventInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventInfoFromJSON(json: any): ApiResultOfJsonEventInfo {
    return ApiResultOfJsonEventInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventInfoToJSON(value?: ApiResultOfJsonEventInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

